/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthModule } from './auth/auth.module';
import { KeycloakCallbackComponent } from './auth/pages/keycloak-callback/keycloak-callback.component';
import { PagesModule } from './pages/pages.module';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { GuestGuard } from './shared/guards/guest.guard';
import { PermissionsGuard } from './shared/guards/permissions.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => AuthModule, canActivate: [GuestGuard] },
  // Volta do Keycloak (modo keycloak): sem GuestGuard, a sessão ainda não existe aqui.
  { path: 'oidc/callback', title: 'Entrando', component: KeycloakCallbackComponent },
  {
    path: 'dash',
    loadChildren: () => PagesModule,
    canActivate: [PermissionsGuard]
  },
  { path: '**', title: 'Página não encontrada', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
